module.exports = __webpack_public_path__ + "img/14_25.f66d069b.png";